import { IServiceDosage } from '@alberta/konexi-shared';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { returnDurationText } from 'src/app/business/general/duration2text-factory';
import { ServiceOrderedServiceLineViewModel } from 'src/app/business/service-order-entity/view-model/service-ordered-service-line-view-model';

@Component({
  selector: 'itl-medical-order-service-data',
  templateUrl: 'medical-order-service-data.component.html',
  styleUrls: ['medical-order-service-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MedicalOrderServiceDataComponent {
  @Input() serviceLine: ServiceOrderedServiceLineViewModel;

  public serviceExpanded = false;

  constructor(private _translate: TranslateService) {}

  public getDosageDisplayText(dosage: IServiceDosage) {
    let displayText = dosage.quantity + ' ' + this._translate.instant('medicalOrder.create.durationTimesPer') + ' ';
    displayText +=
      dosage.quantity === 1
        ? returnDurationText(this._translate, dosage.duration.timePeriod)
        : dosage.duration.amount + ' ' + returnDurationText(this._translate, dosage.duration.timePeriod, true);
    return displayText;
  }

  public toggleShowMore() {
    this.serviceExpanded = !this.serviceExpanded;
  }
}
